// extracted by mini-css-extract-plugin
export default {"header":"rRdcwdACn0BnxuVqA1VL","headerIcon":"lXRbxjQd5HB5xEQ_ue1u","headerIconWrapper":"cV9uewXJzI1QvhXl2Daq","headerText":"wP3ZOwUWhGcbD_8bI8Md"};